import { Dropdown, Menu } from 'antd';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import {
  useAutoTranslateConfig,
  useSetAutoTranslateConfig,
} from 'hooks/business/im/chatPreference';

interface SendButtonProps {
  translating: boolean;
  sendBtnDisable: boolean;
  doSend: () => void;
}

export const SendButton = (props: SendButtonProps) => {
  const { translating, sendBtnDisable, doSend } = props;
  const autoTranslate = useAutoTranslateConfig();
  const setAutoTranslate = useSetAutoTranslateConfig();
  const { t } = useTranslate();

  return (
    <Dropdown.Button
      loading={autoTranslate && translating}
      disabled={sendBtnDisable}
      onClick={doSend}
      type="primary"
      icon={<DownOutlined />}
      trigger={['click']}
      overlay={
        <Menu
          selectedKeys={[autoTranslate ? '2' : '1']}
          onClick={({ key }) => {
            setAutoTranslate(key === '2');
          }}
        >
          <Menu.Item key="1">
            {t('scene.chatWorkspace.messageEditor.action.sendDirectly')}
          </Menu.Item>
          <Menu.Item key="2">
            {t('scene.chatWorkspace.messageEditor.action.sendAfterTranslation')}
          </Menu.Item>
        </Menu>
      }
    >
      {autoTranslate
        ? t('scene.chatWorkspace.messageEditor.action.sendAfterTranslation')
        : t('scene.chatWorkspace.messageEditor.action.sendDirectly')}
    </Dropdown.Button>
  );
};
